import { store } from '_helpers'

export function getPanelCount(noteId, section = '', subsection = '') {
    let panels = getPanels(noteId, section, subsection);
    return panels.length;
}

export function getPanels(noteId, section = '', subsection = '') {
    let state = store.getState();
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let retval;

    var templates = noteType === 1 ?
        Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
            .filter(key => state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBEVNO === pk)
            .map(key => state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO)
        :
        Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
            .filter(key => state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBNTNO === pk)
            .map(key => state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO)
        ;

    var xref = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATEPANELXREF)
        .filter(key => templates.includes(state.entities.notes.PTOBJECTIVETEMPLATEPANELXREF[key].TPXTENO))
        .map(key => state.entities.notes.PTOBJECTIVETEMPLATEPANELXREF[key].TPXMOPNO);

    var panels = [...new Set(xref)];

    if (section === '') {
        retval = Object.keys(state.entities.masterData.PTMASTEROBJECTIVEPANELS)
            .filter(key => panels.includes(state.entities.masterData.PTMASTEROBJECTIVEPANELS[key].MOPNO))
            .sort((a, b) => state.entities.masterData.PTMASTEROBJECTIVEPANELS[a].MOPORDER - state.entities.masterData.PTMASTEROBJECTIVEPANELS[b].MOPORDER)
            .map(key => state.entities.masterData.PTMASTEROBJECTIVEPANELS[key]);
    } else if (subsection === '') {
        retval = Object.keys(state.entities.masterData.PTMASTEROBJECTIVEPANELS)
            .filter(key => panels.includes(state.entities.masterData.PTMASTEROBJECTIVEPANELS[key].MOPNO)
                && state.entities.masterData.PTMASTEROBJECTIVEPANELS[key].MOPSECTION === section)
                .sort((a, b) => state.entities.masterData.PTMASTEROBJECTIVEPANELS[a].MOPORDER - state.entities.masterData.PTMASTEROBJECTIVEPANELS[b].MOPORDER)
                .map(key => state.entities.masterData.PTMASTEROBJECTIVEPANELS[key]);
            } else {
        retval = Object.keys(state.entities.masterData.PTMASTEROBJECTIVEPANELS)
            .filter(key => panels.includes(state.entities.masterData.PTMASTEROBJECTIVEPANELS[key].MOPNO)
                && state.entities.masterData.PTMASTEROBJECTIVEPANELS[key].MOPSECTION === section
                && state.entities.masterData.PTMASTEROBJECTIVEPANELS[key].MOPSUBSECTION === subsection)
                .sort((a, b) => state.entities.masterData.PTMASTEROBJECTIVEPANELS[a].MOPORDER - state.entities.masterData.PTMASTEROBJECTIVEPANELS[b].MOPORDER)
                .map(key => state.entities.masterData.PTMASTEROBJECTIVEPANELS[key]);
            }
    return retval;
}

export function isPanelOnNote(noteId, name) {
    let panels = getPanels(noteId);
    let panel = panels.find(key => panels[key].MOPNAME === name);
    return panel === undefined ? false : true;
}